import { render } from "./Singlet_4_front.vue?vue&type=template&id=06238445"
import script from "./Singlet_4_front.vue?vue&type=script&lang=js"
export * from "./Singlet_4_front.vue?vue&type=script&lang=js"

import exportComponent from "/srv/users/dyo-frontend/apps/dyo-frontend/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__